import React, { useEffect, useRef, useState } from 'react';
import energyandwater from '../../../../assets/shapes_svg/output/energyandwater.svg';
import { getHighlight } from '../../../../apis/Ambition';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';

export const EnergyAndWater = () => {
  const [textEnergy, setTextEnergy] = useState();
  const [textWater, setTextWater] = useState();
  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({
      key: "energyinitiative",
      setValue: setTextEnergy
    });
    getHighlight({
      key: "waterinitiative",
      setValue: setTextWater
    });
  };
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}><b>Energy</b> & <b>Water</b></h4>
        <img src={energyandwater} style={{width:"2%"}} alt="" />
      </div>
      <div className="energyandwater__body">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.3/PRINT_WIDTH,"rem") }}>{textEnergy}</h5>
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.3/PRINT_WIDTH,"rem") }}>{textWater}</h5>
      </div>
    </div>
  );
};
